import { render, staticRenderFns } from "./helpListPage.vue?vue&type=template&id=f491a0c2&"
import script from "./helpListPage.vue?vue&type=script&lang=js&"
export * from "./helpListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports